module.exports = __webpack_public_path__ + "img/footer-button-old.e521660.webp";